import { render, staticRenderFns } from "./EmployeesListComponent.vue?vue&type=template&id=13646e68&"
import script from "./EmployeesListComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeesListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports